"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Shading = exports.FooterWrapper = exports.AsidePortalContent = exports.AsidePortalWrapper = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const wl_ui_kit_1 = require("@invent/wl-ui-kit");
const basePositionCSS = (0, styled_components_1.css) `
  top: 0;
  right: 0;
  bottom: 0;
`;
const genPosition = (position) => {
    if ((position === null || position === void 0 ? void 0 : position.left) || (position === null || position === void 0 ? void 0 : position.left) === 0) {
        return (0, styled_components_1.css) `
      top: 0;
      bottom: 0;
      left: ${position.left}px;
    `;
    }
    if ((position === null || position === void 0 ? void 0 : position.right) || (position === null || position === void 0 ? void 0 : position.right) === 0) {
        return (0, styled_components_1.css) `
      top: 0;
      right: ${position.right}px;
      bottom: 0;
    `;
    }
    return basePositionCSS;
};
exports.AsidePortalWrapper = (0, styled_components_1.default)(wl_ui_kit_1.Card) `
  position: fixed;
  ${({ $position }) => genPosition($position)}
  z-index: ${wl_ui_kit_1.Z_INDEXES.LIGHTBOX};
  display: flex;
  flex-direction: column;
  height: auto;
  border-radius: 0;

  &.react-resizable {
    position: fixed;
  }
`;
exports.AsidePortalContent = (0, styled_components_1.default)(wl_ui_kit_1.CardContent).attrs({ as: 'main' }) `
  flex-grow: 1;
  padding: ${(0, wl_ui_kit_1.getSizeBy)(6)};
  overflow-y: auto;
`;
exports.FooterWrapper = styled_components_1.default.div `
  padding: ${(0, wl_ui_kit_1.getSizeBy)(3.5)} ${(0, wl_ui_kit_1.getSizeBy)(4)} ${(0, wl_ui_kit_1.getSizeBy)(3.5)} ${(0, wl_ui_kit_1.getSizeBy)(4)};
  border-top: ${(0, wl_ui_kit_1.getSizeBy)(0.25)} solid ${(0, wl_ui_kit_1.getColor)('surface')};
  box-shadow: 0 -${(0, wl_ui_kit_1.getSizeBy)(0.25)} ${(0, wl_ui_kit_1.getSizeBy)(1)} ${(0, wl_ui_kit_1.getColorShade)('onSurface', 'outline')};
`;
exports.Shading = styled_components_1.default.div `
  position: fixed;
  z-index: ${wl_ui_kit_1.Z_INDEXES.LIGHTBOX};
  inset: 0;
  background-color: ${(0, wl_ui_kit_1.getColorShade)('onSurface', 'lowEmphasis')};
`;
